import React, { useEffect, useRef } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Formik, Form, Field } from "formik";
import { PostNilDip, UpdateNilDip } from "../../../Service/_index";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import { ToastError } from "../../../UiComponents/Toaster/Toast";
import Styles from "../../../UiComponents/Scss/AddPopup.module.scss";
import { Switch, FormControlLabel } from "@mui/material";

const AddNilDip = (props) => {
    const {
        selectedData,
        formType,
        setOpenDrawer,
        title,
        GetData,
    } = props;
    let formRef = useRef();

    const initialValues = {
        value: "",
        Description: "",
        isActive: true,
    };

    const UserId = sessionStorage.getItem("UserId");

    useEffect(() => {
        if (formType === "edit") {
            const editValues = {
                value: selectedData.value || "",
                Description: selectedData.Description || "",
                isActive: selectedData.isActive !== undefined ? selectedData.isActive : true,
            };
            formRef.setValues(editValues);
        }
    }, [formType, selectedData]);

    const onKeyDownHandler = (e, values) => {
        if (e.key === "Enter") {
            e.preventDefault();
            onSubmit(e, values, "Save");
        }
    };

    const onSubmit = (e, data, keys) => {
        if (e && e.preventDefault) e.preventDefault();

        const processedData = { ...data };
        processedData.updatedAt = new Date();

        if (keys === "Save" || (e && e.key === "Enter")) {
            if (processedData.value) {
                if (formType === "add") {
                    processedData.createdBy = UserId;
                } else if (formType === "edit") {
                    processedData.updatedBy = UserId;
                }

                let SubmitType =
                    formType === "edit"
                        ? UpdateNilDip(selectedData._id, processedData)
                        : PostNilDip(processedData);

                SubmitType.then((res) => {
                    if (res) {
                        setOpenDrawer(false);
                        GetData();
                    }
                }).catch((error) => {
                    console.log(error);
                });
            } else {
                ToastError("Please fill all required fields!");
            }
        } else if (keys === "Save&Create") {
            if (processedData.value) {
                PostNilDip(processedData).then((res) => {
                    if (res) {
                        formRef.resetForm();
                        GetData();
                    }
                });
            } else {
                ToastError("Please fill all required fields!");
            }
        }
    };

    return (
        <div className="DrawerContainer">
            <Grid container className="DrawerHeader">
                <Grid item xs={6} sm={6}>
                    <Typography>{title} Nil Dip</Typography>
                </Grid>
                <Grid item xs={6} sm={6} className="d-flex justify-content-end">
                    <CloseIcon
                        onClick={() => setOpenDrawer(false)}
                        sx={{ cursor: "pointer" }}
                    />
                </Grid>
            </Grid>
            <Formik
                initialValues={initialValues}
                onSubmit={(values) => {
                    onSubmit(null, values, "Save");
                }}
                innerRef={(ref) => {
                    if (ref) {
                        formRef = ref;
                    }
                }}
            >
                {({ values, setFieldValue }) => (
                    <Form onKeyDown={(e) => onKeyDownHandler(e, values)}>
                        <div className={Styles.addContent}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <Typography
                                        className={Styles.inputTitle}
                                        sx={{ fontSize: "12px", mb: 1 }}
                                    >
                                        Depreciation Value *
                                    </Typography>
                                    <Field
                                        name="value"
                                        type="number"
                                        placeholder="Enter Value"
                                        className="InputFiled"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography
                                        className={Styles.inputTitle}
                                        sx={{ fontSize: "12px", mb: 1 }}
                                    >
                                        Description
                                    </Typography>
                                    <Field
                                        name="Description"
                                        placeholder="Enter Description"
                                        className="InputFiled"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={values.isActive}
                                                onChange={(e) => setFieldValue("isActive", e.target.checked)}
                                                color="primary"
                                            />
                                        }
                                        label="Active"
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        <div className="Dialog_Footers">
                            <div className="Dialog_Button_Groups">
                                <Button
                                    onClick={() => setOpenDrawer(false)}
                                    className="Dialog_Cancels"
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    onClick={(e) => onSubmit(e, values, "Save")}
                                    className="Dialog_Saves"
                                >
                                    {formType === "edit" ? "Update" : "Save & Exit"}
                                </Button>
                            </div>
                            {formType === "add" && (
                                <Button
                                    className="Dialog_Save_Exits"
                                    sx={{ marginLeft: "10px" }}
                                    onClick={(e) => onSubmit(e, values, "Save&Create")}
                                >
                                    Save & Create New
                                </Button>
                            )}
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default AddNilDip;
